<template>
  <div class="inv-trans-device">
    <div class="change-title ub ub-sp">
      <el-radio-group
        v-model="formSearch.bizState"
        @change="onPageChange({ page: 1 })"
      >
        <el-radio-button
          v-for="(item,index) in deviceStateList"
          :key="index"
          :label="item.value"
        >{{item.label}}</el-radio-button>
      </el-radio-group>
    </div>
    <div
      class="table-bd"
      v-if="formSearch.bizState"
    >
      <!-- 在途中 -->
      <custom-table
        key="1"
        v-if="formSearch.bizState === '15'"
        :data="tableList"
        tableCode="inv_trans_device_on_the_way"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
      >
        <template v-slot:action="scope">
          <span></span>
          <el-button
            v-if="sendBtnVisible"
            type="text"
            size="mini"
            @click="onReceive(scope.row)"
          >{{ $t('crm_inv_trans_device.shou_huo') }}</el-button>
        </template>
      </custom-table>
      <!-- 已收货 -->
      <custom-table
        key="2"
        v-if="formSearch.bizState === '21'"
        :data="tableList"
        tableCode="inv_trans_device_has_receive"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>

    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
    rule: {
      type: Object,
      default() {
        return {};
      }
    },
    bizId: String
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    // 登录人是入库方才能收货
    sendBtnVisible() {
      const userInfo = this.userInfo;
      const detail = this.detail;
      if (userInfo && userInfo.rootOrgId) {
        return userInfo.rootOrgId === detail.inOrgId;
      }
      return false;
    }
  },
  data() {
    return {
      formSearch: {
        bizId: '',
        bizState: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1
      },

      tableList: [],
      totalRows: 0,
      // 设备业务状态，12-待发货，15-在途中，21-已收货
      deviceStateList: [
      ]
    };
  },
  mounted: function () {
    this.getDicArrMap('transfer_order_biz_state', (data) => {
      this.deviceStateList = data.transfer_order_biz_state.filter(item => item.code !== 'dfh');
      this.formSearch.bizState = this.deviceStateList[0].value;
      this.getTableList();
    });

  },
  methods: {
    onReceive(row) {
      this.$showConfirm(this.$t('crm_inv_trans_device.sfqrsh')).then(() => {
        const orderId = this.bizId;
        const deviceList = [row];
        const reqData = {
          orderId,
          deviceList
        };
        this.$postJSON(apis.transferOrderReceive, reqData, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    // 获取表格数据列表
    getTableList: function () {
      const reqData = {
        ...this.formSearch,
        orderId: this.bizId
      };
      this.$getJSON(apis.transferOrderDevicePage, reqData).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.breakTime = item.endRentDate;
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.inv-trans-device {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
}
</style>
